<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table" :current-page="currentPage" :per-page="perPage">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template v-slot:cell(paziente)="{ item }">
                        <span>
                            <b> {{ item.cognomePaziente }} {{ item.nomePaziente }} </b>
                        </span>
                    </template>
                    <template v-slot:cell(operatore)="{ item }">
                        <span>
                            <b> {{ item.lastnameUpdater }} {{ item.firsnameUpdater }} </b>
                        </span>
                    </template>
                    <template v-slot:cell(createDate)="{ item }">
                        <span>
                            <b> {{ formatDateTime(item.createDate) }} </b>
                        </span>
                    </template>
                    <template v-slot:cell(dataOraEsecuzione)="{ item }">
                        <span>
                            <b> {{ formatDateTime(item.dataOraEsecuzione) }} </b>
                        </span>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            items: [],
            fields: [
                { label: "N.", key: "index", thStyle: "width: 3rem" },
                { label: "Paziente", key: "paziente" },
                { label: "Attivita", key: "nomeAttivita" },
                { label: "Operatore", key: "operatore" },
                { label: "Area", key: "area" },
                { label: "Diario", key: "denominazioneDiario" },
                { label: "Data Creazione", key: "createDate" },
                { label: "Data Esecuzione", key: "dataOraEsecuzione" },
            ],
            perPage: 50,
            currentPage: 1,
            page: 1,
            listKey: 0,
            rows: 0,
            pathResource: "/rsadiarivoci",
        };
    },
    methods: {
        loadData(filtro) {
            let me = this;
            me.$emit("beforeLoadData");
            UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData");
            console.error("Errore durante il caricamento dei dati:", error);
        },
    },
};
</script>
